import { Box, Grid, Typography, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import ControlPanel from '../../ControlPanel';

const useStyles = makeStyles((theme) => ({
  dashboardContainer: {
    paddingTop: theme.spacing(2),
    height: '100%',
    minHeight: '600px',
  },
  gridContainer: {
    height: '100%',
    margin: 0,
    width: '100%',
    flexDirection: 'column',
    display: 'flex',
    flexWrap: 'nowrap',
    [theme.breakpoints.up('lg')]: {
      flexWrap: 'wrap',
      flexDirection: 'row',
    },
  },
  leftPanel: {
    height: '100%',
    width: '100%',
    paddingRight: theme.spacing(1.5),
    flexDirection: 'row',
    display: 'flex',

    [theme.breakpoints.up('lg')]: {
      flexDirection: 'column',
      flex: '0 0 330px',
      maxWidth: '330px',
    },
    [theme.breakpoints.down('md')]: {
      paddingRight: 0,
      paddingBottom: theme.spacing(2),
      height: 'min-content',
    },
  },
  rightPanel: {
    height: '100%',
    width: '100%',
    paddingLeft: theme.spacing(1.5),
    [theme.breakpoints.up('lg')]: {
      flex: '1 1 auto',
      maxWidth: 'calc(100% - 330px)',
    },
    [theme.breakpoints.down('md')]: {
      paddingLeft: 0,
      paddingTop: theme.spacing(1),
    },
  },
  emptyState: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    flexDirection: 'column',
    background: 'white',
    borderRadius: 8,
    border: '1px solid #E6E9F0',
  },
  emptyStateText: {
    color: '#9196A6',
    fontSize: 16,
    marginTop: theme.spacing(2),
  },
}));

const LoadingState = ({
  onExport,
  onExportChart,
  isPngExporting,
  isPdfExporting,
  isDataExporting,
}) => {
  const classes = useStyles();
  const { en: { populationHealth } } = useSelector((state) => state.i18n);

  return (
    <Box className={classes.dashboardContainer}>
      <Grid container className={classes.gridContainer}>
        <Grid item className={classes.leftPanel}>
          <ControlPanel
            onExport={onExport}
            onExportChart={onExportChart}
            isPngExporting={isPngExporting}
            isPdfExporting={isPdfExporting}
            isDataExporting={isDataExporting}
          />
        </Grid>
        <Grid item className={classes.rightPanel}>
          <Box className={classes.emptyState}>
            <Typography variant="h6">
              {populationHealth?.loadingPopulationHealthData || 'Loading population health data...'}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default LoadingState;
